import React from 'react';
import { ErrorMessage } from 'formik';

import BasicLabel from 'components/BasicLabel';
import CheckboxOrRadioGroup from 'components/CheckboxOrRadioGroup';
import CheckboxMultiSelect from 'components/CheckboxMultiSelect';
import LanguageSelectGroup from 'components/LanguageSelectGroup';

const FormStep1 = ({
  values,
  options,
  errors,
  isValid,
  touched,
  dirty,
  handleChange,
  handleBlur,
  handleSubmit,
  handleReset,
  isSubmitting,
  setFieldValue,
  setFieldError,
  setFieldTouched,
}) => {
  return (
    <div className="form__step">
      <div className="form__group" style={{ marginBottom: '15px' }}>
        <div className="form__row">
          <BasicLabel
            name="bs"
            required={false}
            text="Investment Strategy Interests"
            styles={{
              fontWeight: 'bold',
            }}
          />
        </div>
        <CheckboxMultiSelect
          name="bs"
          label="Please select all that apply"
          labelStyles={{
            fontSize: '0.9286rem',
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: '400',
            textTransform: 'none',
          }}
          isValid={(!errors.bs && !!touched.bs) || !touched.bs}
          required={true}
          items={options.bs}
          selectedItems={values.bs}
          placeholder=""
          groups={false}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
        />

        <ErrorMessage
          name="bs"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>
      <div className="form__group" style={{ marginBottom: '15px' }}>
        <div className="form__row">
          <BasicLabel
            name="loc"
            required={false}
            text="Location Preferences"
            styles={{
              fontWeight: 'bold',
            }}
          />
        </div>
        <CheckboxMultiSelect
          name="loc"
          label="Please select all that apply"
          labelStyles={{
            fontSize: '0.9286rem',
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: '400',
            textTransform: 'none',
          }}
          isValid={(!errors.loc && !!touched.loc) || !touched.loc}
          required={true}
          items={options.loc}
          selectedItems={values.loc}
          placeholder=""
          groups={false}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
        />
        <ErrorMessage
          name="loc"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>
      <div className="form__group" style={{ marginBottom: '15px' }}>
        <div className="form__row">
          <BasicLabel
            name="fs"
            required={false}
            text="Fund Size Preferences"
            styles={{
              fontWeight: 'bold',
            }}
          />
        </div>
        <CheckboxMultiSelect
          name="fs"
          label="Please select all that apply"
          labelStyles={{
            fontSize: '0.9286rem',
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: '400',
            textTransform: 'none',
          }}
          isValid={(!errors.fs && !!touched.fs) || !touched.fs}
          required={true}
          items={options.fs}
          selectedItems={values.fs}
          placeholder=""
          groups={false}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
        />
        <ErrorMessage
          name="fs"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>
      <div className="form__group" style={{ marginBottom: '15px' }}>
        <div className="form__row">
          <BasicLabel
            name="manageAccount"
            required={true}
            text="I manage my personal account"
            styles={{
              fontWeight: 'bold',
            }}
          />
        </div>
        <div className="form__row">
          <CheckboxOrRadioGroup
            name="manageAccount"
            type="radio"
            options={['Yes', 'No']}
            selectedOptions={values.manageAccount}
            directionRow={true}
            controlFunc={handleChange}
          />
        </div>
        <ErrorMessage
          name="manageAccount"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>

      <div className="form__group" style={{ marginBottom: '15px' }}>
        <div className="form__row">
          <BasicLabel
            name="openOp"
            required={true}
            text="I am open to immediate start opportunities"
            styles={{
              fontWeight: 'bold',
            }}
          />
        </div>
        <div className="form__row">
          <CheckboxOrRadioGroup
            name="openOp"
            type="radio"
            options={['Yes', 'No']}
            selectedOptions={values.openOp}
            directionRow={true}
            controlFunc={handleChange}
          />
        </div>
        <ErrorMessage
          name="openOp"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>

      <div className="form__group" style={{ marginBottom: '15px' }}>
        <div className="form__row">
          <BasicLabel
            name="lang"
            required={false}
            text="Foreign Languages"
            styles={{
              fontWeight: 'bold',
            }}
          />
        </div>
        <LanguageSelectGroup
          name="lang"
          values={values.lang}
          isValid={(!errors.lang && !!touched.lang) || !touched.lang}
          required={false}
          languageOptions={options.lang}
          levelOptions={options.langLevel}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
        />

        <ErrorMessage
          name="lang"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>

      <div className="form__group" style={{ marginBottom: '30px' }}>
        <div className="form__row">
          <BasicLabel
            name="citizenshipLabel"
            required={true}
            text="Citizenship"
            styles={{
              fontWeight: 'bold',
            }}
          />
        </div>
        <CheckboxMultiSelect
          name="citizenship"
          isValid={
            (!errors.citizenship && !!touched.citizenship) ||
            !touched.citizenship
          }
          required={true}
          items={options.citizenship}
          selectedItems={values.citizenship}
          placeholder=""
          groups={false}
          showSearch={true}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
        />
        <ErrorMessage
          name="citizenship"
          render={message => <div className="form__error">{message}</div>}
        />
      </div>
    </div>
  );
};

export default FormStep1;
